import { Link } from '@/navigation';

function NoResultLabel() {
  return (
    <div
      className="py-[80px] text-center text-base font-medium leading-6
  tracking-[-0.176px] text-3b-text-secondary"
    >
      No results found.
      <br />
      Please check if there is an alias gene name:{' '}
      <Link
        href="https://www.genenames.org/"
        className="no-underline-offset underline-auto underline-from-font underline decoration-solid"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://www.genenames.org/
      </Link>
      .
    </div>
  );
}

export default NoResultLabel;
